import { obterPlanosManutencaoAsync, obterPlanosEquipamentoAsync } from "../../services/planoManutencaoService";

const atualizarPlanosManutencao = async ({ commit }) => {
    const planosManutencao = await obterPlanosManutencaoAsync();
    commit('atualizarPlanosManutencao', planosManutencao);
}

const atualizarPlanosEquipamento = async ({ commit }, idEquipamento) => {
    const planosEquipamento = await obterPlanosEquipamentoAsync(idEquipamento);
    commit('atualizarPlanosEquipamento', planosEquipamento);
}
const atualizarPlanoManutencao = ({ commit }, planoManutencao) => {
    commit('atualizarPlanoManutencao', planoManutencao);
}

const updatePlanoManutencao = ({ commit }, planoManutencao) => {
    commit('updatePlanoManutencao', planoManutencao);
}

export default {
    atualizarPlanosManutencao,
    atualizarPlanoManutencao,
    atualizarPlanosEquipamento,
    updatePlanoManutencao
}